'use client'

import Script from 'next/script'

/**
 * Google Analytics 4 Component
 *
 * Add your GA4 Measurement ID to enable tracking.
 *
 * Setup:
 * 1. Go to https://analytics.google.com
 * 2. Create a property for dday.io
 * 3. Get your Measurement ID (starts with G-)
 * 4. Add to .env: NEXT_PUBLIC_GA_MEASUREMENT_ID=G-XXXXXXXXXX
 *
 * This component only loads in production to avoid polluting analytics with dev data.
 */

interface GoogleAnalyticsProps {
  measurementId?: string
  environment?: string
}

export function GoogleAnalytics({
  measurementId,
  environment,
}: GoogleAnalyticsProps) {
  // Only load GA in production and if ID is configured
  if (!measurementId || environment !== 'production') {
    return null
  }

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${measurementId}`}
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${measurementId}', {
            page_path: window.location.pathname,
          });
        `}
      </Script>
    </>
  )
}
